module.exports = __webpack_public_path__ + "static/media/Facebook_Button@3x.bdfc2fe5.png";